import React, { ReactElement } from 'react';
import ChoiceOption from '@/components/ChoiceOption';
import { DragIndicatorIcon } from 'elmo-elements';
import { Draggable } from 'react-beautiful-dnd';
import { ChoiceDataType } from '@/modules/types/choice';

const SortableChoice = (props: {
  item: ChoiceDataType;
  index: number;
}): ReactElement => (
  <Draggable
    key={props.item.id}
    draggableId={props.item.id}
    index={props.index}
  >
    {(providedDrag) => (
      <div
        ref={providedDrag.innerRef}
        {...providedDrag.draggableProps}
        {...providedDrag.dragHandleProps}
        className="elmoca-dnd-draglist-item"
      >
        <ChoiceOption
          title=""
          description={props.item.content}
          icon={<DragIndicatorIcon />}
          className="mb-0"
          iconRight=""
        />
      </div>
    )}
  </Draggable>
);

export default SortableChoice;
